import React, { Component } from 'react';
import { BaseTextBox } from '../../controls/BaseTextBox';
import { FormattedMessage } from 'react-intl';
import { BaseCheckBox } from '../../controls/BaseCheckBox';
import orderService from '../OrderService';
import { BaseTextArea } from '../../controls/BaseTextArea';
import { EarmoldHearingLossDataView } from './EarmoldHearingLossDataView';
import Toast from '../../controls/BaseToast';

export class EarmoldCustomerView extends Component {

    constructor(props) {
        super(props);
        this.state = { propertyChanged: false };

        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleEarSurgery = this.handleEarSurgery.bind(this);
        this.handleEarInflammation = this.handleEarInflammation.bind(this);
        this.handleEardrumOrderType = this.handleEardrumOrderType.bind(this);
        this.hearingLossRef = React.createRef();
    }

    notifyPropertyChanged() {
        let propertyChanged = !this.state.propertyChanged;
        this.setState({ propertyChanged: propertyChanged });
    }

    handleInputChange(event) {
        const target = event.target;
        const value = target.value;
        const name = target.name;

        var model = this.props.model;
        if (model) {
            switch (name) {
                case "customerName":
                    model.customerName = value;
                    break;
                case "customerAge":
                    model.customerAge = value;
                    break;
                case "specialRequirements":
                    model.specialRequirements = value;
                    break;
                case "hearingAidModel":
                    model.hearingAidModel = value;
                    break;
                case "lastEardrumNumber":
                    model.lastEardrumNumber = value;
                    break;
            }

            this.notifyPropertyChanged();
        }
    }



    handleEardrumOrderType(event) {
        const target = event.target;
        const checked = target.checked;
        const value = target.value;
        if (value === "1") {
            Toast.warn("RedoOnlySupportsOfflineTip");
            return;
        }
        if (value === "2") {
            Toast.warn("CorrectOnlySupportsOfflineTip");
            return;
        }

        var model = this.props.model;
        if (model) {
            if (checked) {
                model.eardrumOrderType = parseInt(value);
            }
            else {
                model.eardrumOrderType = -1;
            }
            this.notifyPropertyChanged();
        }
    }

    handleEarSurgery(event) {
        const target = event.target;
        const checked = target.checked;
        const value = target.value;
        var model = this.props.model;
        if (model) {
            if (checked) {
                model.earSurgery = parseInt(value);
            }
            else {
                model.earSurgery = -1;
            }
            this.notifyPropertyChanged();
        }
    }

    handleEarInflammation(event) {
        const target = event.target;
        const checked = target.checked;
        const value = target.value;
        var model = this.props.model;
        if (model) {
            if (checked) {
                model.earInflammation = parseInt(value);
            }
            else {
                model.earInflammation = -1;
            }
            this.notifyPropertyChanged();
        }
    }

    CheckFieldRequiredInvalid(field) {

        let trimfield = !field ? '' : field.trim();
        if (trimfield === '') {
            return true;
        }
        return false;
    }

    validate() {
        var model = this.props.model;
        if (this.CheckFieldRequiredInvalid(model.customerName)) {
            return { state: false, msg: "CustomerNameRequired" };
        }
        if (!/^\d*$/.test(model.customerAge) || model.customerAge <= 0) {
            return { state: false, msg: "CustomerAgeRequiredIngeter" }
        }
        if (model.eardrumOrderType == 3 && this.CheckFieldRequiredInvalid(model.lastEardrumNumber)) {
            return { state: false, msg: "LastEardrumNumberRequired" };
        }

        let result = this.hearingLossRef.current.validate();
        if (!result.state) {
            return result;
        }

        return { state: true, msg: "success" };
    }

    render() {
        let model = this.props.model;
        if (!model) {
            return null;
        }

        return <div className="flex gap-6 w-full">
            <div className="grid grid-cols-6 gap-x-6 gap-y-3">
                <div className="col-span-6 sm:col-span-3">
                    <label className="block text-sm font-medium text-gray-700"><FormattedMessage id="CustomerName" /><span className="font-bold text-red-600">*</span></label>
                    <BaseTextBox classnames="mt-1" name="customerName" type="text" value={model.customerName ?? ""} onChange={this.handleInputChange} />
                </div>
                <div className="col-span-6 sm:col-span-3">
                    <label className="block text-sm font-medium text-gray-700"><FormattedMessage id="CustomerAge" /></label>
                    <BaseTextBox classnames="mt-1" type="text" name="customerAge" value={model.customerAge ?? ""} onChange={this.handleInputChange} />
                </div>
                <div className="col-span-6">
                    <label className="block text-sm font-medium text-gray-700"><FormattedMessage id="UserHistory" /></label>
                    <div className="grid grid-cols-2 pt-1">
                        <div className="flex items-center gap-1">
                            <label className="block text-sm font-medium text-gray-700"><FormattedMessage id="EarSurgery" /></label>
                            <div className="flex ml-4">
                                <label className="inline-flex items-center">
                                    <BaseCheckBox type="checkbox" value={0} checked={model.earSurgery === 0} onChange={this.handleEarSurgery}></BaseCheckBox>
                                    <span class="ml-1"><FormattedMessage id="No" /></span>
                                </label>
                                <label className="inline-flex items-center">
                                    <BaseCheckBox classnames="ml-1" type="checkbox" value={1} checked={model.earSurgery === 1} onChange={this.handleEarSurgery}></BaseCheckBox>
                                    <span class="ml-1"><FormattedMessage id="Yes" /></span>
                                </label>
                            </div>
                        </div>
                        <div className="flex items-center gap-1">
                            <label className="block text-sm font-medium text-gray-700"><FormattedMessage id="EarInflammation" /></label>
                            <div className="flex  ml-4 ">
                                <label className="inline-flex items-center">
                                    <BaseCheckBox type="checkbox" value={0} checked={model.earInflammation === 0} onChange={this.handleEarInflammation}></BaseCheckBox>
                                    <span class="ml-1"><FormattedMessage id="No" /></span>
                                </label>
                                <label className="inline-flex items-center">
                                    <BaseCheckBox classnames="ml-1" type="checkbox" value={1} checked={model.earInflammation === 1} onChange={this.handleEarInflammation}></BaseCheckBox>
                                    <span class="ml-1"><FormattedMessage id="Yes" /></span>
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-span-6">
                    <EarmoldHearingLossDataView ref={this.hearingLossRef} model={model} leftRightOption={this.props.leftRightOption} />
                </div>
                <div className="col-span-6">
                    <label ><FormattedMessage id="SpecialRequirements" /></label>
                    <BaseTextArea name="specialRequirements" value={model.specialRequirements ?? ""} onChange={this.handleInputChange}></BaseTextArea>

                </div>

            </div>
            <div className="grid grid-cols-6 gap-6">
                <div className="col-span-6">
                    <lable className="block text-sm font-medium text-gray-700"><FormattedMessage id="HearingAidModel" /></lable>
                    <BaseTextBox classnames="mt-1" type="text" name="hearingAidModel" value={model.hearingAidModel ?? ""} onChange={this.handleInputChange} />
                </div>

                <div className="col-span-6">
                    <div className="text-base font-medium text-gray-900"><FormattedMessage id="EardrumOrderType" /></div>
                    <div className="mt-4 space-y-4">
                        <div className="border-gray-200">
                            <div className="flex justify-start">
                                <div className="place-self-center inline-flex items-center">
                                    <BaseCheckBox type="checkbox" name="eardrumOrderType0" onChange={this.handleEardrumOrderType} value={0} checked={model.eardrumOrderType === 0} ></BaseCheckBox>
                                    <span className="ml-1"><FormattedMessage id="NewEarMold" /></span>
                                </div>
                            </div>
                        </div>
                        <div className="border-gray-200">
                            <div className="flex justify-start">
                                <div className="place-self-center inline-flex items-center">
                                    <BaseCheckBox type="checkbox" name="eardrumOrderType3" value={3} checked={model.eardrumOrderType === 3} onChange={this.handleEardrumOrderType}></BaseCheckBox>
                                    <span className="ml-1"><FormattedMessage id="NewEarMoldAlreadySamples" /></span>
                                </div>
                            </div>
                        </div>
                        <div className="border-gray-200">
                            <div className="flex justify-start">
                                <div className="place-self-center inline-flex items-center">
                                    <BaseCheckBox type="checkbox" name="eardrumOrderType1" value={1} checked={model.eardrumOrderType === 1} onChange={this.handleEardrumOrderType}></BaseCheckBox>
                                    <span className="ml-1"><FormattedMessage id="Repair" /></span>
                                </div>
                            </div>
                        </div>
                        <div className="border-gray-200">
                            <div className="flex justify-start">
                                <div className="place-self-center inline-flex items-center">
                                    <BaseCheckBox type="checkbox" name="eardrumOrderType2" value={2} checked={model.eardrumOrderType === 2} onChange={this.handleEardrumOrderType}></BaseCheckBox>
                                    <span className="ml-1"><FormattedMessage id="RedoEarMold" /></span>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>

                <div className="col-span-6">
                    <label className="block text-sm font-medium text-gray-700"><FormattedMessage id="LastEardrumNumber" /></label>
                    <BaseTextBox disabled={model.eardrumOrderType <= 1 ? true : false} type="text" name="lastEardrumNumber" value={model.lastEardrumNumber ?? ""} onChange={this.handleInputChange} />
                </div>
            </div>
        </div>
    }
}
